export default __webpack_public_path__ + "static/media/waterfall.92413451.jpg";